import {Printer} from "../../entities/Printer";
import {PrinterService} from "../../services/PrinterService";
import {EditModel} from "./EditModel";

export class EditPrinterModel extends EditModel<Printer> {
    entityId:number;
    static $inject = ['$q','PrinterService'];
    constructor($q:ng.IQService, service:PrinterService){
        super($q, service, Printer);
    }
    getNewEntity():Printer{
        return new Printer();
    }
}
